var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8648 0C11.0364 0 10.3648 0.671573 10.3648 1.5V10.3636H1.5C0.671573 10.3636 0 11.0352 0 11.8636V12.1363C0 12.9648 0.671573 13.6363 1.5 13.6363H10.3648V22.5C10.3648 23.3284 11.0364 24 11.8648 24H12.1375C12.9659 24 13.6375 23.3284 13.6375 22.5V13.6363H22.5C23.3284 13.6363 24 12.9648 24 12.1363V11.8636C24 11.0352 23.3284 10.3636 22.5 10.3636H13.6375V1.5C13.6375 0.671573 12.9659 0 12.1375 0H11.8648Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/iconAdd.9fba0b3ac36e37d526b1c69befbae7a1.svg";
export { ForwardRef as ReactComponent };